module.exports = __webpack_public_path__ + "static/media/1 demon angel wings tattoo backpiece realism realistic.1280x1707.74b89020.webp";